import { Checkbox } from 'antd';
import { ContactConnectionsTableColumns } from '../../tables/tableTypes/contact/column';
import { useMemo } from 'react';

interface IdOptionProps {
    model: any;
    selected: boolean;
    columnKey: string;
}
const IdOption: FCWithChildren<IdOptionProps> = (props) => {
    const selectedModel = useMemo(() => {
        if (props.columnKey === ContactConnectionsTableColumns.ConnectedMember) {
            return `${props.model.firstName} ${props.model.lastName}`;
        } else if (props.columnKey === ContactConnectionsTableColumns.Campaign) {
            return props.model.name;
        }
        return undefined;
    }, [props.columnKey]);

    return (
        <Checkbox checked={props.selected}>
            <span>{selectedModel}</span>
        </Checkbox>
    );
};

export default IdOption;
